import React, { useRef } from "react";
import styled from "styled-components";

const Style = styled.div`
   position: relative;
    .container {
        position: absolute;
        top: -4rem;
        left: calc(50% - 4rem);
        width: 8rem;
        height: 4rem;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        --color: var(--fsc-d-1);
        --color-2: var(--prime-2);
        &.dark{
            --color: #fff;
            --color-2: var(--prime-2);
        }
        .text {
            padding: 0.3rem 0 0.5rem;
            border: 1px solid var(--color-2);
            border-radius: 48px;
            color: var(--color);
            text-align: center;
            font-size: 0.8rem;
            font-weight: 600;
        }
        .icon {
            flex-grow: 1;
            display: flex;
            justify-content: center;
            svg {
                margin: auto;
                fill: var(--color-2);
            }
        }
    }
`;

export default function ReadMore({data}) {
    const ref = useRef()
    const scrollOneScreen = () => {
        let pos = window.scrollY + window.innerHeight - 60;
        if(data.data.getBtm){
            var screenPosition = ref.current.getBoundingClientRect();
            pos = window.scrollY + screenPosition.y - 60;
        }
        window.scrollTo({
            top: pos,
            behavior: "smooth"
        })
    }
    return (
      <Style ref={ref}>
        <div className={"container " + data.data.theme} onClick={scrollOneScreen}>
            <div className="text">{data.data.text}</div>
            <div className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M3.54975 8.41967C3.84264 8.12677 4.31752 8.12677 4.61041 8.41967L11.1304 14.9397C11.6075 15.4168 12.3926 15.4168 12.8697 14.9397L19.3897 8.41967C19.6826 8.12677 20.1575 8.12677 20.4504 8.41967C20.7433 8.71256 20.7433 9.18743 20.4504 9.48033L13.9304 16.0003C12.8675 17.0632 11.1326 17.0632 10.0697 16.0003L3.54975 9.48033C3.25685 9.18743 3.25685 8.71256 3.54975 8.41967Z"/>
                </svg>
            </div>
        </div>
      </Style>
  );
}
